/**
 * Defines the cloud choice of the API domains.
 *
 * @public
 */
export enum CloudChoice {
  GLOBAL_MULTI = 'GLOBAL-MULTI', //All available cloud regions
  GLOBAL_GCP = 'GLOBAL-GCP', //Only available GCP-backed cloud regions
}
